import { BCRate, IRateProps } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import InputControl from '../../base/InputControl';
import IRateProperties from './entities/IRateProperties';
import { IPropertyField, MultiLanguageText } from '../../../../entities/common';
import Styles from './assets/styles.scss';

export default class Rate extends InputControl<number> {
	count: number;
	allowClear: boolean;
	allowHalf: boolean;
	tooltips?: Array<MultiLanguageText>;

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.Rate;
		this.count = 5;
		this.allowHalf = false;
		this.allowClear = false;
		this.tooltips = [];

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			this.triggerValueChanged(Number(value) || null);
		});
	}

	__getMLClassPath() {
		return [...super.__getMLClassPath(), 'tooltips.__array__'];
	}

	__loadProperties(data: IRateProperties) {
		super.__loadProperties(data);
		this.__proxyChanged.count = data.count;
		this.__proxyChanged.allowClear = data.allowClear;
		this.__proxyChanged.allowHalf = data.allowHalf;

		if (data?.tooltips) {
			if (data.tooltips.length) {
				const newTooltips: Array<MultiLanguageText> = [];
				data.tooltips.forEach(tooltip => {
					const newTooltipItem = new MultiLanguageText();
					newTooltipItem.setData(tooltip);
					newTooltips.push(newTooltipItem);
				});

				this.__proxyChanged.tooltips = newTooltips;
			} else {
				this.__proxyChanged.tooltips = [];
			}
		}
	}

	private triggerValueChanged(value: number) {
		this.__proxyChanging.value = value;
	}

	private triggerHoverChange(value: number) {
		//todo bu kısma bakılacak
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'value',
				type: 'number',
				common: true
			},
			{
				name: 'count',
				type: 'number'
			},
			{
				name: 'allowClear',
				type: 'boolean'
			},
			{
				name: 'allowHalf',
				type: 'boolean'
			}
		];
	}

	__getComponentData(): IRateProps & IDictionary<any> {
		return {
			...super.__getComponentData(),
			count: this.count,
			allowClear: this.allowClear && !this.readOnly,
			allowHalf: this.allowHalf,
			tooltips: this.tooltips.map(t => t.getData()) as any
		};
	}

	__render(children?: JSX.Element) {
		return super.__render(
			<BCRate
				count={this.count}
				allowClear={this.allowClear}
				allowHalf={this.allowHalf}
				tooltips={this.tooltips.map(t => t.getText())}
				disabled={this.__isDisabled()}
				readOnly={this.__isReadOnly()}
				value={this.value}
				onChange={this.triggerValueChanged.bind(this)}
				onHoverChange={this.triggerHoverChange}
				style={{
					width: '100%',
					backgroundColor: this.style.backgroundColor
				}}
				className={Styles.fillStar}
			/>
		);
	}
}
